export default __webpack_public_path__ + "how_it_works_desktop.3d1d7477.png";